module.exports = __webpack_public_path__ + "img/second-modal-background.9b5f8705.jpg";